(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/bet-proposal/assets/javascripts/services/fetch-bet-proposal.js') >= 0) return;  svs.modules.push('/components/marketplace-data/bet-proposal/assets/javascripts/services/fetch-bet-proposal.js');
"use strict";


const cachedJupiterGet = svs.components.marketplaceData.cachedJupiterGet;
const helpers = svs.components.marketplaceData.betProposal.helpers;
const fetchBetProposal = (_ref, callback) => {
  let activatedDrawId = _ref.activatedDrawId,
    groupId = _ref.groupId,
    productName = _ref.productName;
  const successCb = _ref2 => {
    let preliminaryRow = _ref2.preliminaryRow,
      isPrivate = _ref2.isPrivate;
    let rows = [];
    if (preliminaryRow) {
      var _JSON$parse = JSON.parse(preliminaryRow);
      rows = _JSON$parse.rows;
    }
    callback(null, helpers.normalizeBetProposal(rows, productName), isPrivate);
  };
  const errorCb = err => callback(err.responseJSON.error);
  fetchBetProposal.cacheRequest("/marketplace/1/activateddraws/".concat(activatedDrawId, "/preliminarywagers?groupId=").concat(groupId), successCb, errorCb);
};
fetchBetProposal.cacheRequest = cachedJupiterGet.createCache(1000);
setGlobal('svs.components.marketplaceData.betProposal.services.fetchBetProposal', fetchBetProposal);

 })(window);